module.exports = __webpack_public_path__ + "img/logoScalens.2bb9506a.png";